import { Coord } from "../../../../../../../src/types/Interface";
import getAngleBetweenPoints from "../../../../../../../src/utils/math/getAngleBtwPoints";
import generatePoints from "../../../../../../../src/utils/generator/generatePoints";
import { normalizeRadian } from "../../../../../../../src/utils/math/normalizeRadian";


export function findIntersecCoord(pointCoords: Coord[]) {
	const [pointA, pointB, pointC, pointD] = pointCoords;
	// y = m * x + b
	const slopeA = Math.tan(normalizeRadian(getAngleBetweenPoints(pointA, pointC)));
	const slopeB = Math.tan(normalizeRadian(getAngleBetweenPoints(pointB, pointD)));

	// b = y - m * x
	const bA = pointA.y - slopeA * pointA.x;
	const bB = pointB.y - slopeB * pointB.x;

	// x = (b2 - b1) / (m1 - m2)
	const x = Number(((bB - bA) / (slopeA - slopeB)).toFixed(2));
	const y = Number((slopeB * x + bB).toFixed(2));
	return { x, y }
}

export function generateChordPoints(cCoord: Coord, circleRadius: number, pointRadian: number, intersecRadius: number) {
	if (!cCoord || !circleRadius || !pointRadian || !intersecRadius) {
		return Array(3).fill({ x: 0, y: 0 });
	}
	const intersecCoord = generatePoints(cCoord, [pointRadian], intersecRadius)[0];
	const sideLength = Math.sqrt(Math.pow(circleRadius, 2) - Math.pow(intersecRadius, 2));

	const getCoord = (radian: number) => ({
		x: intersecCoord.x + Math.cos(radian) * sideLength,
		y: intersecCoord.y + Math.sin(radian) * sideLength
	});

	return [getCoord(pointRadian + Math.PI / 2), intersecCoord, getCoord(pointRadian - Math.PI / 2)];
}